import React from "react";
import { useTranslation } from "react-i18next";

import AppBar from "../components/AppBar";
import DestinationsComponent from "../components/Destinations";
import ToursComponent from "../components/Tours";
import Footer from "../components/Footer";
import FloatingActionButtonSize from "../components/FloatingButton";
import { Button } from "../components/ui/button";

import florianopolis from "../assets/images/florianopolis.jpeg";
import logo from "../assets/images/logo.png";

function HomePage() {
  const { t } = useTranslation();

  const services = [
    {
      title: t("home.services.executiveTransfers.title"),
      description: t("home.services.executiveTransfers.description"),
    },
    {
      title: t("home.services.airportReception.title"),
      description: t("home.services.airportReception.description"),
    },
    {
      title: t("home.services.customExperiences.title"),
      description: t("home.services.customExperiences.description"),
    },
  ];

  return (
    <>
      <div className="relative isolate min-h-screen overflow-hidden bg-slate-950 text-white">
        <div className="absolute inset-0">
          <img
            src={florianopolis}
            alt={t("home.imageAlt")}
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-slate-950" />
        </div>
        <AppBar />
        <section className="relative z-10 mx-auto flex min-h-[620px] max-w-5xl flex-col items-center gap-8 px-6 py-24 text-center md:py-32">
          <img src={logo} alt="Transfer On Floripa" className="w-40" />
          <p className="max-w-3xl text-lg text-slate-100 md:text-xl">
            {t("home.welcome")}
          </p>
          <div className="flex flex-col items-center gap-4 sm:flex-row">
            <Button size="lg" asChild>
              <a
                href="https://wa.me/5548996523066"
                target="_blank"
                rel="noreferrer"
              >
                {t("home.whatsapp")}
              </a>
            </Button>
            <Button variant="ghost" size="lg" asChild>
              <a href="#destinations">{t("home.exploreDestinations")}</a>
            </Button>
          </div>
          <dl className="grid w-full gap-6 rounded-3xl bg-white/10 p-6 text-left shadow-2xl backdrop-blur">
            <div>
              <dt className="text-sm uppercase tracking-[0.3em] text-slate-300">
                {t("home.destinationsCount")}
              </dt>
              <dd className="text-2xl font-semibold">
                {t("home.exclusiveExperiences")}
              </dd>
            </div>
          </dl>
        </section>
      </div>

      <section id="services" className="bg-background">
        <div className="mx-auto flex max-w-5xl flex-col gap-12 px-6 py-16">
          <div className="text-center">
            <p className="text-sm font-semibold uppercase tracking-[0.4em] text-primary">
              {t("home.executiveTourism")}
            </p>
            <h2 className="mt-3 text-3xl font-bold text-slate-900 md:text-4xl">
              {t("home.premiumMobility")}
            </h2>
          </div>
          <div className="grid gap-6 md:grid-cols-3">
            {services.map((service) => (
              <article
                key={service.title}
                className="rounded-3xl border border-border bg-white p-6 shadow-sm"
              >
                <h3 className="text-lg font-semibold text-slate-900">
                  {service.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                  {service.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <span id="destinations">
        <DestinationsComponent />
      </span>

      <span id="tours">
        <ToursComponent />
      </span>

      <Footer />
      <FloatingActionButtonSize />
    </>
  );
}

export default HomePage;
